<div class="modal-fator-ecg">
    <div class="modal-header">
        <h4 class="modal-title">Inclusão de Fator de ECG</h4>
        <button _ngcontent-jop-c162="" type="button" aria-label="Close" class="btn-close float-end" (click)="fechar()"></button>
    </div>
    <div class="modal-body">
        
        <label class="form-label"><b>Qtde. meses prazo inicial</b></label>
        <input bnMask="DECIMAL" class="form-control" [(ngModel)]="fatorEcg.quantidadeMesesPrazoTotalInicial" disabled/>

        <label class="form-label"><b>Qtde. meses prazo final</b></label>
        <input bnMask="DECIMAL" class="form-control" [(ngModel)]="fatorEcg.quantidadeMesesPrazoTotalFinal" (ngModelChange)="verificarCamposPreenchidos()"/>
 
        <label class="form-label"><b>Valor do fator (%)</b></label>
        <input bnMask="DECIMAL"casasDecimais="2" class="form-control" [(ngModel)]="fatorEcg.valorFatorEcg" (ngModelChange)="verificarCamposPreenchidos()"/>

        <!--div *ngIf="mensagemAviso" class="alert alert-warning">
            {{mensagemAviso}}
        </div-->

    </div>
    <div class="modal-footer">
        <button class="btn btn-danger" (click)="cancelar()">Cancelar</button>
        <button class="btn btn-success" [disabled]="!todosCamposPreenchidos" (click)="salvar()">Adicionar</button>
    </div>
</div>
